import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getProfileImage(idpersona) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-profile-image`, {
      params: {
        idpersona: idpersona
      },
      responseType: 'blob',
     });
    return response

  } catch (error) {
    console.error('Error al obtener las imagenes de perfil', error);
  }
}